/** 游戏相关接口 */
import request from '@/utils/util.request';

/*
 *  (raffle) 抽奖大转盘 加载数据
 *  @param {string} media_id | null: 媒体ID
 */
export const raffle_load_data = (data) => {
	return request({
		url: '/raffle/loaddata',
		data,
	});
};

/*
 *  (raffle) 抽奖大转盘 保存
 *  @param {string} name: 名字
 *  @param {array} items: 奖项列表
 *  @param {int} trys_per_day: 单日抽奖次数
 */
export const raffle_save = (data) => {
	return request({
		url: '/raffle/save',
		data,
	});
};

/*
 *  (rain) 红包雨 加载数据
 *  @param {string} media_id | null: 媒体ID
 */
export const rain_load_data = (data) => {
	return request({
		url: '/rain/loaddata',
		data,
	});
};

/*
 *  (rain) 红包雨 保存
 */
export const rain_save = (data) => {
	return request({
		url: '/rain/save',
		data,
	});
};
